export default __webpack_public_path__ + "static/SVGCard02-577d0362576acafb690b04e865e1758b.svg";